import DealerErrorsFactory from '../Errors/factory.js'
import ContactInformationValueObject from './ContactInformationValueObject.js'
import {DealerServiceValueObject} from './DealerServiceValueObject.js'
import {DealersListValueObject} from './DealersListValueObject.js'
import ResultValueObject from './ResultValueObject.js'
import {TrackingPhoneDealerValueObject} from './TrackingPhoneDealerValueObject.js'
import {TrackingPhoneRequestParamsDealerValueObject} from './TrackingPhoneRequestParamsDealerValueObject.js'

export default class DealerValueObjectsFactory {
  /**
   * @method
   * @params {Object} deps
   * @property {String} deps.ok
   * @return {ResultValueObject}
   */
  static resultValueObject = ({ok}) => {
    ResultValueObject.validate({ok})
    return new ResultValueObject({ok})
  }

  /**
   * @method
   * @property {Object} deps
   * @property {String} deps.name
   * @property {String} deps.phone
   * @property {String} deps.email
   * @property {String} deps.stock
   * @property {String} deps.callMeNow
   * @return {ContactInformationValueObject}
   */
  static contactInformationValueObject = ({name, phone, email, stock, callMeNow}) => {
    ContactInformationValueObject.validate({name, phone, email})
    return new ContactInformationValueObject({
      name,
      phone,
      email,
      stock,
      callMeNow
    })
  }

  static trackingPhoneRequestParamsDealerValueObject = ({
    adId,
    adobeAccount,
    adobeMarketingCloudVisitorId,
    adobeTrackingServer,
    adobeVersion,
    contractId,
    filteredProvinces,
    pageType,
    referrer = '',
    sessionId,
    url
  }) => {
    TrackingPhoneRequestParamsDealerValueObject.validate({
      adId,
      contractId,
      errorFactory: DealerErrorsFactory.trackingPhoneError
    })

    return new TrackingPhoneRequestParamsDealerValueObject({
      adId,
      adobeAccount,
      adobeMarketingCloudVisitorId,
      adobeTrackingServer,
      adobeVersion,
      contractId,
      filteredProvinces,
      pageType,
      referrer,
      sessionId,
      url
    })
  }

  static trackingPhoneDealerValueObject = ({sessionId, phoneNumber, trackingId}) =>
    new TrackingPhoneDealerValueObject({sessionId, phoneNumber, trackingId})

  /**
   * @return {DealerServiceValueObject}
   */
  static dealerServiceValueObject = ({type, title, description, isIncluded}) => {
    DealerServiceValueObject.validate({
      type,
      title,
      dealerServiceDealerErrorFactory: DealerErrorsFactory.dealerServiceDealerError
    })

    return new DealerServiceValueObject({type, title, description, isIncluded})
  }

  /**
   * @method
   * @param {Object} deps
   * @param {Array} deps.items
   * @param {Number} deps.totalPages
   * @param {Number} deps.totalResults
   * @return {DealersListValueObject}
   */
  static dealersListValueObject = ({items, totalPages, totalResults}) =>
    new DealersListValueObject({items, totalPages, totalResults})
}
